import React, { useState } from 'react';

export default function StreamOverlay(props) {
	return <div>Stream Overlay</div>;
}
